import { AvatarPlayground } from "../AvatarPlayground";
import { InstitutionIconPlayground } from "../InstitutionIconPlayground";
import { KeyboardShortcutsPlayground } from "../KeyboardShortcutsPlayground";
import { KickLogoPlayground } from "../KickLogoPlayground";
import { PresenceStackPlayground } from "../PresenceStackPlayground";
import { SubaccountPlayground } from "../SubaccountPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const identityIconsEntries: PlaygroundComponentEntry[] = [
    {
        id: "avatar",
        label: "Avatar",
        description:
            "Figma user icon and user group: photo or initial, circle or square, stacked with a +N chip.",
        group: "ready-components",
        render: () => <AvatarPlayground />,
    },
    {
        id: "presence-stack",
        label: "Presence stack",
        description:
            "A board card's 20px avatar stack: the agent on top, viewers, then the assignee or team, with a presence tooltip per avatar and an optional assignee button.",
        group: "components",
        render: () => <PresenceStackPlayground />,
    },
    {
        id: "institution-icon",
        label: "InstitutionIcon",
        description:
            "Figma institution icon: a bank, provider or AI logo in a circle, from the catalogue or a URL, with a bank fallback.",
        group: "ready-components",
        render: () => <InstitutionIconPlayground />,
    },
    {
        id: "kick-logo",
        label: "KickLogo",
        description:
            "Figma KickLogo and KickIcon: the full logo or the square or circle icon, black or white, opaque or transparent.",
        group: "ready-components",
        render: () => <KickLogoPlayground />,
    },
    {
        id: "subaccount",
        label: "Subaccount",
        description: "Subaccount label rendering.",
        group: "components",
        render: () => <SubaccountPlayground />,
    },
    {
        id: "shortcut",
        label: "Shortcut",
        description: "Key chips for a hotkey string, per platform and size.",
        group: "ready-components",
        render: () => <KeyboardShortcutsPlayground />,
    },
];
